@if (!loading && tasks.length > 0) {
    <section pfSection [pfTitle]="title + ' (' + tasks.length + ')'">
        <div class="task-list">
            @for (group of groupedTasks; track group.group) {
                <div class="task-group">
                    <pf-chip
                        class="task-group__chip"
                        [class.task-group__chip--parts]="
                            !group.oldestTaskPriority && group.group === 'Parts'
                        "
                        [class.task-group__chip--uniforms]="
                            !group.oldestTaskPriority &&
                            group.group === 'Uniforms'
                        "
                        [icon]="group.oldestTaskIconType"
                        [pfStatus]="
                            group.oldestTaskPriority ? 'danger' : 'primary'
                        ">
                        {{ group.group }}
                    </pf-chip>
                    @if (group.oldestTask) {
                        <cpw-task-list-item
                            [task]="group.oldestTask"
                            [readonly]="group.oldestTask.readonly"
                            (taskSelected)="
                                taskSelected.emit(group.oldestTask)
                            "></cpw-task-list-item>
                    }
                    @if (group.otherTasks.length > 0) {
                        <pf-content-collapsible
                            [pfHeader]="group.otherTasksTitle">
                            <div class="collapsible-tasks">
                                @for (task of group.otherTasks; track task.id) {
                                    <cpw-task-list-item
                                        [task]="task"
                                        [readonly]="
                                            task.readonly
                                        "></cpw-task-list-item>
                                }
                            </div>
                        </pf-content-collapsible>
                    }
                </div>
            }
        </div>
    </section>
} @else {
    @if (loading) {
        <nz-spin>{{ loadingText }}</nz-spin>
    } @else {
        <section pfSection [pfTitle]="title">
            <div class="task-list-empty--compact">
                <pf-icon iconType="list" size="md"></pf-icon>
                <span>{{ emptyText }}</span>
            </div>
        </section>
    }
}
